module.exports = __webpack_public_path__ + "static/media/whoscall.c51ce3f1.jpg";